import IProfile from "./profile";

export enum ETaskType {
    Weekly,
    Periodic
}
export type ETaskTypeKeysType = keyof typeof ETaskType;

export default interface ITask {
    id: number;
    name: string;
    description: string;
    type: ETaskType;
}

export interface ITaskProfile {
    task: ITask;
    profile: IProfile;
}
export interface TaskData {
    name: string;
    description: string;
    type: ETaskType;
}
